import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { Button, Icon, TextField } from '@seeqdev/qomponents';

interface IrregularScheduleProps {
  schedules: string[];
  onConvertIt: () => void;
  disabled?: boolean;
}

export const IrregularSchedule = ({ schedules, onConvertIt, disabled = false }: IrregularScheduleProps) => {
  const { t } = useTranslation();

  return (
    <div data-testid="live-schedule-config" className="tw:mb-sq-15">
      <label>{t('SCHEDULE_TYPE.IRREGULAR_SCHEDULE')}</label>
      {_.map(schedules, (schedule) => (
        <TextField
          key={schedule}
          disabled={true}
          extraClassNames="mb15"
          testId="irregular-schedule-config__cron-schedule"
          type="text"
          value={schedule}
        />
      ))}

      <div className="flexColumnContainer tw:items-start">
        <Icon icon="fa-info-circle" large={true} extraClassNames="tw:p-1 tw:cursor-pointer tw:rounded-sm" />
        <span>{t('SCHEDULE_TYPE.IRREGULAR')}</span>
        <Button
          testId="irregular-schedule-config__convert-it"
          extraClassNames="width-250"
          label={t('SCHEDULE_TYPE.IRREGULAR_CONVERT_IT')}
          onClick={onConvertIt}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
